// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#css__kxpCBQ{background:transparent;margin:0!important;padding:0!important;position:relative}#css__kxpCBQ .css__SweRwH{z-index:2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"branch_offices": "css__kxpCBQ",
	"breadcrumbs": "css__SweRwH"
};
module.exports = ___CSS_LOADER_EXPORT___;
